module.exports = __webpack_public_path__ + "img/np-mobile-2.acffc998.webp";